const handleCoordinatorDelete = (id, objectModified) =>
  objectModified(currentValues =>
    currentValues.filter(
      ({ id_funcionario_coordenador: idCoordenador }) => idCoordenador !== id,
    ),
  );

const handleCoordinatorInsert = objectModified => {
  objectModified(currentValues => [
    ...currentValues,
    { id_funcionario_coordenador: -1 },
  ]);
};

const handleCoordinatorUpdate = (index, coordinatorId, objectModified) => {
  objectModified(currentValues =>
    currentValues.map((value, currentIndex) => {
      if (currentIndex === index) {
        return {
          id_funcionario_coordenador: coordinatorId,
        };
      }

      return value;
    }),
  );
};

export {
  handleCoordinatorDelete,
  handleCoordinatorInsert,
  handleCoordinatorUpdate,
};
